﻿import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from 'react-query';

import { TextInput } from 'components/Form';
import { PeopleIcon, SearchIcon } from 'components/Icon';
import styleVars_14 from "styles/colors.module.scss";
const { turquoise01  } = styleVars_14;
import { useBranch } from 'components/BranchProvider';
import { TABLE, THEAD, TBODY, TH, TR } from 'components/Table';
import { TYPES } from 'helpers/note';

import ProspectRow from './ProspectRow';
import NotesModalWidget from 'containers/NotesModalWidget';
import AddNoteModalWidget from 'containers/AddNoteModalWidget';

import theme from "./ProspectsTable.module.sass";

export const NOTES_MODAL_ID = 'ProspectsWidget/NotesWidges';
export const ADD_NOTE_MODAL_ID = 'ProspectsWidget/AddNoteModalWidget';

const prospectsTableDefaultPropProspects = [];
const ProspectsTable = ({ prospects = prospectsTableDefaultPropProspects, onActionClick }) => {
  const [branch] = useBranch();
  const queryClient = useQueryClient();

  const [searchResults, setSearchResults] = useState();
  const [typingTimeout, setTypingTimeout] = useState();

  const filterResult = searchResults || prospects;
  const total = filterResult.length;
  const searchCompare = (prospect, clientName) =>
    `${prospect.profile.first_name} ${prospect.profile.last_name}`
      .toLowerCase()
      .includes(clientName.toLowerCase());
  return (
    <div className={theme.ProspectsTable}>
      <div className={theme.TableHeader}>
        <div className={theme.Title}>
          <PeopleIcon fill={turquoise01} />
          <h1>Prospects</h1>
        </div>
        <TextInput
          placeholder="Search a client"
          icon={<SearchIcon fill={turquoise01} />}
          onChange={(ev) => {
            const clientName = ev.target.value;
            if (typingTimeout) {
              clearTimeout(typingTimeout);
            }
            setTypingTimeout(
              setTimeout(() => {
                if (clientName) {
                  setSearchResults(
                    prospects.filter((prospect) =>
                      searchCompare(prospect, clientName),
                    ),
                  );
                } else {
                  setSearchResults(null);
                }
              }, 1000),
            );
          }}
        />
      </div>
      <div className={theme.ResultsCount}>{`${total} clients`}</div>
      <NotesModalWidget modalId={NOTES_MODAL_ID} types={[TYPES.general]} />
      <AddNoteModalWidget
        modalId={ADD_NOTE_MODAL_ID}
        onNoteAdded={() => {
          queryClient.invalidateQueries(['clients', 'prospects']);
        }}
      />
      <TABLE>
        <THEAD>
          <TR>
            <TH>Clear Skin Specialist</TH>
            <TH>Client</TH>
            <TH>Status</TH>
            {branch.show_next_appointment_enabled && <TH>Appt Date</TH>}
            <TH>Action</TH>
            <TH>Notes</TH>
          </TR>
        </THEAD>
        <TBODY>
          {filterResult.map((prospect, key) => (
            <ProspectRow
              key={key}
              prospect={prospect}
              onActionClick={onActionClick}
            />
          ))}
        </TBODY>
      </TABLE>
    </div>
  );
};

ProspectsTable.propTypes = {
  prospects: PropTypes.array,
  onActionClick: PropTypes.func,
};

export default ProspectsTable;
